// extracted by mini-css-extract-plugin
export default {"root":"Thumb__root--2qP57","borderRadius":"Thumb__borderRadius--u0N9V"};